module.exports = __webpack_public_path__ + "img/epr@2x.b5cc0304.jpeg";